import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { NotificationResource, RenderExampleRequest } from '@apaq/orgkit-js';
import { DialogRef } from 'src/app/modules/dialog/dialog-ref';
import { DATA, DIALOG } from 'src/app/modules/dialog/dialog.service';
import { container } from 'tsyringe';

export interface Data {
  event: string;
  template: string;
  templateMode: 'Default' | 'Custom';
}

@Component({
  selector: 'app-notification-template-editor-view',
  templateUrl: './notification-template-editor-view.component.html',
  styleUrls: ['./notification-template-editor-view.component.scss']
})
export class NotificationTemplateEditorViewComponent  {

  _preview = false;
  renderedExample?: string;
  //markdown = md();

  constructor(@Inject(DIALOG) private dialog: DialogRef, @Inject(DATA) public data: Data,
    private notificationService: NotificationResource) {
    this.render();
  }

  get preview() {
    return this._preview;
  }

  set preview(value: boolean) {
    this._preview = value;

    if (value === true) {
      const template = this.data.templateMode === 'Default' ? null : this.data.template;
      Stallion.alert('Should have server render example here');
      const request: RenderExampleRequest = {
        event: this.data.event,
        template: template! // TODO: Should not be required
      }
      this.notificationService.renderExample(request).then(n => {
        this.renderedExample = n.text;
      })
      //this.renderedExample = (await this.notificationService.renderExample(request))?.text;
        //this.renderedExample = this.markdown.render(n.text.replace('\n', '  \n'));
      //});
    }
  }

  render() {
    const template = this.data.templateMode === 'Default' ? null : this.data.template;
      //Stallion.alert('Should have server render example here');
      const request: RenderExampleRequest = {
        event: this.data.event,
        template: template! // TODO: Should not be required
      }
      this.notificationService.renderExample(request).then(n => {
        this.renderedExample = n.text;
      })
  }

  close() {
    this.dialog.close();
  }

  ok() {
    this.dialog.close(this.data);
  }

}
